import { render, staticRenderFns } from "./cjgl.vue?vue&type=template&id=16f7827c&scoped=true"
import script from "./cjgl.vue?vue&type=script&lang=js"
export * from "./cjgl.vue?vue&type=script&lang=js"
import style0 from "../../views/ksgl-page/assets/css/rem.css?vue&type=style&index=0&id=16f7827c&prod&scoped=true&lang=css&external"
import style1 from "./cjgl.vue?vue&type=style&index=1&id=16f7827c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f7827c",
  null
  
)

export default component.exports